import { useCallback } from "react";
import { useHistory } from "react-router";
import { Button, ButtonProps } from "@mui/material";

import useAuth from "hooks/useAuth";
import useDialog from "hooks/useDialog";

const UploadTargetsBtn = (props: ButtonProps) => {
  const { isLoggedIn } = useAuth();
  const { setOpenLoginDialog } = useDialog();
  const history = useHistory();
  const handleUploadTargets = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      if (isLoggedIn) {
        if (event.ctrlKey) {
          window.open("/upload-targets", "_blank");
        } else {
          history.push("/upload-targets");
        }
      } else {
        setOpenLoginDialog(true);
      }
      /* eslint-disable react-hooks/exhaustive-deps */
    },
    [isLoggedIn]
  );

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleUploadTargets}
      {...props}
    >
      Upload targets
    </Button>
  );
};

export default UploadTargetsBtn;
